export default "__VITE_ASSET__7cd19f84__"